import { Injectable } from '@angular/core';
import { HttpClient, HttpErrorResponse } from '@angular/common/http';
import { catchError } from 'rxjs/operators';
import { throwError, forkJoin,Subject } from 'rxjs';
import { environment } from 'src/environments/environment';
import { IMapSettings } from '../map-settings/settings';

@Injectable()
export class SettingService {
  private isMapSettingsChanged = new Subject<any>();
  currentMapSettings$ = this.isMapSettingsChanged.asObservable();
  private  baseUrl = environment.baseUrl;
  constructor(private http:HttpClient) { }
  
  changeLocalMapSettings(currentMapData:IMapSettings){
    this.isMapSettingsChanged.next(currentMapData);
  }
  
  // TODO: Remove this api if unused
  getMapTypes() {
    return this.http.get(`${this.baseUrl}/api/Setting/GetMaps`)
          .pipe(
            catchError(this.handleError)
          );
  }
 
  saveMapSettings(data:IMapSettings){
    return this.http.post(`${this.baseUrl}/api/Setting/SaveSetting`, data)
        .pipe(
           catchError(this.handleError)
        );
  }
  getMapSettings(userId:string){
    return this.http.get(`${this.baseUrl}/api/Setting/RetrieveSetting?userId=${userId}`)
        .pipe(
             catchError(this.handleError)
        );
  }

  private handleError(error:HttpErrorResponse) {
    if(error.error instanceof ErrorEvent) {
      console.error('An error occured', error.error.message);
    } else {
      console.error(
        `Backend returned code ${error.status}`
      );
    }
    return throwError(error.error);
  }
}
